import imageCompression from 'browser-image-compression';

import { bucket_url } from "../../../../../../../api/config/parameters"
import { EChoirFileType } from "../../../../../../../common/types/choir/file"

export const getPhotoURL = (photo: string) => {
    if (!photo) return undefined;
    return `${bucket_url}choir/${EChoirFileType.PHOTO}-${photo}.jpg`
};

export const compressImage = async (imageFile: File) => {
    const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    }
    try {
        const compressedFile = await imageCompression(imageFile, options);

        return compressedFile;
    } catch (error) {
        console.log(error);
    }

}

export const getImageDimensions = async (file: File) => {
    return new Promise<{ width: number, height: number }>((resolve, reject) => {
        if (!file || !file.type.startsWith('image/')) {
            reject(new Error('Invalid file type. Please select an image.'));
            return;
        }
        const reader = new FileReader();
        reader.onload = function (event) {
            const image = new Image();
            image.src = event.target.result.toString();

            image.onload = function () {
                resolve(
                    {
                        width: image.naturalWidth,
                        height: image.naturalHeight
                    }
                );
            };
        };
        reader.onerror = function (error) {
            reject(new Error('Error reading image file.'));
        };
        reader.readAsDataURL(file);
    })
}